<template>
	<aside class="sidebar-wrapper sidebar-background-color" :class="{ 'fold-active': foldState }">
		<slot name="header" />

		<div class="sidebar-inner">
			<div class="element-wrapper" v-for="(data, index) in options" :key="index">
				<nested-element
					:user-permission="permission"
					:state="state"
					:permission="data.permission"
					:path="data.path"
					:title="data.name"
					:children="data.children"
					:fold="data.fold"
					:default="data.default"
					:page-name="data.pageName"
					:element-click-event="clickEvent"
					:change-state="pushMove"
				/>
			</div>
		</div>

		<slot name="footer" />
	</aside>
</template>

<script>
import Vue from "vue";
import NestedElement from "./nested-sidebar/NestedElement";

export default {
	name: "Sidebar",
	components: {
		NestedElement
	},
	props: {
		options: {
			isRequired: true
		},
		foldState: {
			type: Boolean,
			default: false
		},
		permission: {
			type: String,
			default: null
		},
		clickEvent: {
			type: Function,
			default: () => {}
		}
	},
	methods: {
		pushMove(pageName) {
			this.state = pageName;
			this.$router.push(pageName).catch(error => {
				if (error.name != "NavigationDuplicated") {
					throw error;
				}
			});
		},

		replaceMove(pageName) {
			this.state = pageName;
			this.$router.replace(pageName).catch(error => {
				if (error.name != "NavigationDuplicated") {
					throw error;
				}
			});
		},

		recursiveFindPathInChildren(target, arr) {
			if (arr === undefined || arr === null) return null;

			for (let i = 0; i < arr.length; i += 1) {
				if (arr[i].pageName === target) return arr[i].path;

				const result = this.recursiveFindPathInChildren(
					target,
					arr[i].children
				);

				if (result !== null) return result;
			}

			return null;
		}
	},
	created() {
		const EventBus = new Vue();

		EventBus.pushMove = this.pushState;
		EventBus.replaceMove = this.replaceMove;

		Object.defineProperties(Vue.prototype, {
			$sidebar: {
				get: () => EventBus,
				configurable: false
			}
		});
	},
	mounted() {
		const currentPath = window.location.href
			.split("#")
			.slice(1)[0]
			.replace("/", "");
		this.pushMove(currentPath);
		this.$set(this, "state", currentPath);

		if (window.innerWidth <= 1024) {
			this.$store.commit("setFoldState", true);
		}
	},
	updated() {
		const currentPath = window.location.href
			.split("#")
			.slice(1)[0]
			.replace("/", "");
		this.pushMove(currentPath);
		this.$set(this, "state", currentPath);
	},
	data() {
		return {
			state: ""
		};
	}
};
</script>

<style lang="scss" scoped>
.sidebar-wrapper {
	position: fixed;

	width: 220px;
	height: 100%;

	overflow-y: scroll;

	transition: margin-left 0.2s ease-in-out 0s;

	&::-webkit-scrollbar {
		display: none;
	}
}

@media screen and (max-width: 1024px) {
	.sidebar-wrapper {
		display: block;
		transition: none;
		-webkit-overflow-scrolling: touch;

		width: 100%;
		z-index: 1000;
	}

	.fold-active {
		display: none;
		margin-left: 0 !important;
	}
}

.sidebar-background-color {
	background-color: rgb(37, 42, 57);
}

.fold-active {
	margin-left: -220px;
}
</style>



// WEBPACK FOOTER //
// src/modules/sidebar/Sidebar.vue